export default __webpack_public_path__ + "static/media/violet1.b7d044c8.svg";